module.exports = __webpack_public_path__ + "img/pin1.9d174af5.png";